import React from 'react'
import * as blueprint from '@adc/blueprint'
import classnames from 'classnames/bind'
import styles from '../styles.scss'

const cx = classnames.bind(styles)

class RentbackOffer extends blueprint.listing.badges.RentbackOffer {
  get content() {
    return (
      <div>
        The seller is requesting to stay in the home after closing:
        <ul className={cx('badge-bullet-list')}>
          <li>This is common in many homes sales.</li>
          <li>
            You'll still own the home, but the seller will remain as an occupant
            for the duration of the lease.
          </li>
          <li>Everything will be clearly written in your offer.</li>
        </ul>
      </div>
    )
  }
}

class RentbackAuction extends blueprint.listing.badges.RentbackAuction {
  static content = '\n* \n* \n* '
  get content() {
    return (
      <div>
        After purchase, the seller will stay in the home for a period of time:
        <ul className={cx('badge-bullet-list')}>
          <li>They'll remain in the home for [X] days after you buy it.</li>
          <li>
            This timing of this lease is already set and part of the sale.
          </li>
          <li>
            All details should be included in your purchase agreement. Please
            consult your attorney and/or agent for further information.
          </li>
        </ul>
      </div>
    )
  }
}

export { RentbackOffer, RentbackAuction }
